<template>
  <v-card
    tile
    flat
    color="grey lighten-5"
    v-if="this.loggedInUser != null && this.pagePermission == true"
  >
    <v-card flat color="grey lighten-5">
      <v-card-title>
        <v-layout row wrap ml-2>
          <v-flex text-left>
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[selectedDate] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="selectedDate = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectedDate = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectedDate = 'quarter'">
                  <v-list-item-title>Quarter</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="selectedDate = 'year'">
                  <v-list-item-title>Year</v-list-item-title>
                </v-list-item> -->
              </v-list>
            </v-menu>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prevDateRange()"
            >
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <span class="subtitle-2">{{ dateRangeText }}</span>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="nextDateRange()"
            >
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-divider></v-divider>
    <v-row>
      <v-col>
        <v-container>
          <v-select
            v-model="selectedUserNames"
            :items="userNames"
            hide-selected
            label="Selected Users"
            multiple
            clearable
            small-chips
            deletable-chips
            tags
            ref="select"
            :disabled="
              loading == true || loadingExpense == true || financeView != true
            "
            @input="updateUserSelect"
          >
          </v-select>
        </v-container>
      </v-col>
    </v-row>
    <v-alert v-if="successMessage != null" dense text type="success">
      {{ successMessage }}
    </v-alert>
    <v-alert v-if="errorMessage != null" dense outlined type="error">
      {{ errorMessage }}
    </v-alert>
    <v-container v-if="financeView == true">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Hours: {{ projectSummaryTotals.hours.toFixed(2) }}
              </span>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Expenses: ${{ projectSummaryTotals.expenses.toFixed(2) }}
              </span>
            </v-col>
            <!-- <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Labor Cost: ${{ projectSummaryTotals.laborCost.toFixed(2) }}
              </span>
            </v-col> -->
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Billed Expenses: ${{
                  projectSummaryTotals.billedExpenses.toFixed(2)
                }}
              </span>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Billed Labor: ${{
                  projectSummaryTotals.billedLabor.toFixed(2)
                }}
              </span>
            </v-col>
          </v-row>
          <!-- <v-row no-gutters>
            <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Revenue: ${{ projectSummaryTotals.revenue.toFixed(2) }}
              </span>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Cost: ${{ projectSummaryTotals.cost.toFixed(2) }}
              </span>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="subtitle-2"
                >Profit: ${{ projectSummaryTotals.profit.toFixed(2) }}
              </span>
            </v-col>
          </v-row> -->
        </v-card-text>
      </v-card>
    </v-container>

    <v-row v-if="financeView == true">
      <v-col>
        <v-container>
          <DataTable
            sortby="projectName"
            title="Project Summary"
            :items="projectSummaryData"
            :headers="projectHeaders"
            :loading="loading"
            :showadd="false"
            :showdaterange="false"
            @error="errorMessage = $event"
          >
          </DataTable>
        </v-container>
      </v-col>
    </v-row>

    <v-row v-if="financeView == true">
      <v-col>
        <v-container>
          <DataTable
            sortby="name"
            title="Team Summary"
            :items="teamSummaryData"
            :headers="teamHeaders"
            :loading="loading"
            :showadd="false"
            :showdaterange="false"
            @error="errorMessage = $event"
          >
          </DataTable>
        </v-container>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-container>
          <DataTable
            sortby="date"
            :sortbydesc="true"
            title="Time Submissions"
            :items="timeSubmissions"
            :headers="timeSubHeaders"
            itemtype="Time Submission"
            :showdaterange="false"
            :loading="loading"
            :showadd="false"
            :loadingtext="loadingText"
            @error="errorMessage = $event"
            @row-click="editTimeSubmission"
          >
          </DataTable>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-container>
          <DataTable
            sortby="date"
            :sortbydesc="true"
            title="Expense Submissions"
            :items="expenseSubmissions"
            :headers="expenseSubHeaders"
            itemtype="Expense Submission"
            :showdaterange="false"
            :showadd="false"
            :loading="loadingExpense"
            :loadingtext="loadingExpenseText"
            @error="errorMessage = $event"
            @row-click="editExpenseSubmission"
          >
          </DataTable>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showTimeSubmissionForm"
      v-if="showTimeSubmissionForm == true"
      max-width="800px"
    >
      <DialogForm
        :userid="submitUserId"
        :action="formAction"
        title="Time Submission"
        :data="timeSubmissionData"
        :lastsubmission="lastSubmission"
        @update-table="updateTable"
        @delete-item="formAction = 'Delete'"
        @success="successHandler"
        @close="showTimeSubmissionForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showExpenseSubmissionForm"
      v-if="showExpenseSubmissionForm == true"
      max-width="800px"
    >
      <DialogForm
        :userid="submitUserId"
        :action="expenseFormAction"
        title="Expense Submission"
        :data="expenseSubmissionData"
        @update-table="updateExpenseTable"
        @delete-item="expenseFormAction = 'Delete'"
        @success="successHandlerExpense"
        @close="showExpenseSubmissionForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showFileDialog"
      v-if="showFileDialog == true"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            class="ma-2"
            color="red"
            @click="showFileDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-img :src="fileLink" contain>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment";
import DataTable from "@/components/DataTable/DataTable.vue";
import DialogForm from "@/components/DialogForm/DialogForm.vue";

export default {
  name: "Analytics",
  components: { DataTable, DialogForm },
  props: ["userid"],
  data: () => ({
    pageName: "Analytics",
    testing: [],
    dates: null,
    dateRangeText: null,
    typeToLabel: {
      month: "Month",
      week: "Week",
      quarter: "Quarter"
      //year: "Year",
    },
    selectedDate: "week",
    financeView: true,
    showTimeSubmissionForm: false,
    showExpenseSubmissionForm: false,
    formAction: null,
    selectedUserNames: [],
    selectedUserIds: [],
    loadedUserNames: [],
    loadedUserIds: [],
    userNames: [],
    userIds: [],
    expenseFormAction: null,
    timeSubmissions: [],
    loadedTimeSubmissions: [],
    expenseSubmissions: [],
    loadedExpenseSubmissions: [],
    loading: false,
    loadingExpense: false,
    loadingText: null,
    loadingExpenseText: null,
    on: null,
    successMessage: null,
    errorMessage: null,
    deleteRow: false,
    showEditSubmissionDialog: false,
    dialogLoading: false,
    dialogSuccessMessage: null,
    dialogErrorMessage: null,
    s3ImageName: null,
    s3ImageContentType: null,
    search: null,
    selectDateRange: false,
    timeSubmissionData: null,
    expenseSubmissionData: null,
    sections: [],
    showFileDialog: false,
    fileLink: null,
    billableTimeSubs: [],
    allTimeSubs: [],
    projectHeaders: [
      {
        text: "Project",
        align: "left",
        value: "projectName",
        sortable: true
      },
      { text: "Hours", value: "hours", sortable: false },
      { text: "Billed Labor", value: "billedLabor", sortable: false },
      //{ text: "Labor Cost", value: "laborCost", sortable: false },
      { text: "Billed Expenses", value: "billedExpenses", sortable: false },
      { text: "Expenses", value: "expenses", sortable: false }
      //{ text: "Revenue", value: "revenue", sortable: false },
      //{ text: "Cost", value: "cost", sortable: false },
      //{ text: "Profit", value: "profit", sortable: false }
    ],
    teamHeaders: [
      {
        text: "User",
        align: "left",
        value: "name",
        sortable: true
      },
      { text: "Hours", value: "hours", sortable: false },
      { text: "Billed Labor", value: "billedLabor", sortable: false }
      //{ text: "Labor Cost", value: "laborCost", sortable: false },
      //{ text: "Profit", value: "profit", sortable: false }
    ],
    timeSubmissionHeadersAll: [
      {
        text: "Date",
        align: "left",
        value: "date",
        sortable: true
      },
      { text: "Project", value: "projectName", sortable: true },
      { text: "Task ID", value: "taskId", sortable: true },
      { text: "Service Type ID", value: "serviceType", sortable: false },
      { text: "User Name", value: "userName", sortable: true },
      { text: "Billable Rate", value: "rate", sortable: false },
      //{ text: "Labor Rate", value: "payRate", sortable: false },
      { text: "Duration", value: "duration", sortable: false },
      { text: "Description", value: "description", sortable: false },
      { text: "Attachment", value: "attachment", sortable: false }
    ],
    expenseSubmissionHeadersAll: [
      {
        text: "Date",
        align: "left",
        value: "date",
        sortable: true
      },
      { text: "Project", value: "projectName", sortable: true },
      { text: "Task", value: "taskId", sortable: true },
      { text: "User Name", value: "userName", sortable: true },
      { text: "Cost", value: "cost", sortable: false },
      { text: "Billed Amount", value: "billedAmount", sortable: false },
      { text: "Description", value: "description", sortable: false },
      { text: "Reimburse", value: "reimburse", sortable: true },
      { text: "Attachment", value: "attachment", sortable: false }
    ],
    expenseSubmissionHeaders: [
      {
        text: "Date",
        align: "left",
        value: "date",
        sortable: true
      },
      { text: "Project", value: "projectName", sortable: true },
      { text: "Cost", value: "cost", sortable: false },
      { text: "Description", value: "description", sortable: false },
      { text: "Attachment", value: "attachment", sortable: false }
    ]
  }),
  computed: {
    projects() {
      return this.$store.getters.getProjects;
    },
    timeSubHeaders() {
      if (this.financeView == true) {
        return this.timeSubmissionHeadersAll;
      } else {
        return this.timeSubmissionHeaders;
      }
    },
    expenseSubHeaders() {
      if (this.financeView == true) {
        return this.expenseSubmissionHeadersAll;
      } else {
        return this.expenseSubmissionHeaders;
      }
    },
    pagePermission() {
      let pagePermission = this.$store.getters.getPagePermission;
      for (var i = 0; i < pagePermission.length; i++) {
        if (this.pageName == pagePermission[i]) {
          return true;
        }
      }
      return false;
    },
    userAdmin() {
      if (this.loggedInUser.type == "Admin") {
        return true;
      } else {
        return false;
      }
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser;
    },
    userStoreData() {
      return this.$store.getters.getUsers;
    },
    submitUserId() {
      return this.userid != null ? this.userid : this.loggedInUser.id;
    },
    teamSummaryData() {
      let teamData = [];
      for (let i = 0; i < this.timeSubmissions.length; i++) {
        let alreadyAdded = false;
        let name = this.timeSubmissions[i].userName;
        let duration = parseFloat(this.timeSubmissions[i].duration);
        let billedLabor = parseFloat(this.timeSubmissions[i].rate * duration);
        let laborCost = parseFloat(this.timeSubmissions[i].payRate * duration);
        for (let j = 0; j < teamData.length; j++) {
          let member = teamData[j];
          if (member.name == name) {
            member.hours = member.hours + duration;
            member.billedLabor = member.billedLabor + billedLabor;
            member.laborCost = member.laborCost + laborCost;
            member.profit = member.profit + billedLabor - laborCost;
            alreadyAdded = true;
          }
        }
        if (alreadyAdded == false) {
          teamData.push({
            name: name,
            hours: duration,
            billedLabor: billedLabor,
            laborCost: laborCost,
            profit: billedLabor - laborCost
          });
        }
      }
      return teamData;
    },
    projectSummaryTotals() {
      let summaryTotals = {
        hours: 0,
        billedLabor: 0,
        laborCost: 0,
        billedExpenses: 0,
        expenses: 0,
        revenue: 0,
        cost: 0,
        profit: 0
      };
      for (let i = 0; i < this.projectSummaryData.length; i++) {
        summaryTotals.hours =
          summaryTotals.hours + this.projectSummaryData[i].hours;
        summaryTotals.billedLabor =
          summaryTotals.billedLabor + this.projectSummaryData[i].billedLabor;
        summaryTotals.laborCost =
          summaryTotals.laborCost + this.projectSummaryData[i].laborCost;
        summaryTotals.billedExpenses =
          summaryTotals.billedExpenses +
          this.projectSummaryData[i].billedExpenses;
        summaryTotals.expenses =
          summaryTotals.expenses + this.projectSummaryData[i].expenses;
        summaryTotals.cost =
          summaryTotals.cost + this.projectSummaryData[i].cost;
        summaryTotals.revenue =
          summaryTotals.revenue + this.projectSummaryData[i].revenue;
        summaryTotals.profit =
          summaryTotals.profit + this.projectSummaryData[i].profit;
      }
      return summaryTotals;
    },
    projectSummaryData() {
      let projectData = [];

      for (let i = 0; i < this.timeSubmissions.length; i++) {
        let alreadyAdded = false;
        let name = this.timeSubmissions[i].projectName;
        let duration = parseFloat(this.timeSubmissions[i].duration);
        let billedLabor = parseFloat(this.timeSubmissions[i].rate * duration);
        let laborCost = parseFloat(this.timeSubmissions[i].payRate * duration);
        for (let j = 0; j < projectData.length; j++) {
          let project = projectData[j];
          if (project.projectName == name) {
            project.hours = project.hours + duration;
            project.billedLabor = project.billedLabor + billedLabor;
            project.laborCost = project.laborCost + laborCost;
            project.revenue = project.revenue + billedLabor;
            project.cost = project.cost + laborCost;
            project.profit = project.profit + billedLabor - laborCost;
            alreadyAdded = true;
          }
        }
        if (alreadyAdded == false) {
          projectData.push({
            projectName: name,
            hours: duration,
            billedLabor: billedLabor,
            laborCost: laborCost,
            billedExpenses: 0,
            expenses: 0,
            revenue: billedLabor,
            cost: laborCost,
            profit: billedLabor - laborCost
          });
        }
      }
      for (let i = 0; i < this.expenseSubmissions.length; i++) {
        let alreadyAdded = false;
        let name = this.expenseSubmissions[i].projectName;
        let expenseCost = parseFloat(this.expenseSubmissions[i].cost);
        let billedAmount = parseFloat(this.expenseSubmissions[i].billedAmount);
        for (let j = 0; j < projectData.length; j++) {
          let project = projectData[j];
          if (project.projectName == name) {
            project.expenses = project.expenses + expenseCost;
            project.billedExpenses = project.billedExpenses + billedAmount;
            project.revenue = project.revenue + billedAmount;
            project.cost = project.cost + expenseCost;
            project.profit = project.profit + billedAmount - expenseCost;
            alreadyAdded = true;
          }
        }
        if (alreadyAdded == false) {
          projectData.push({
            projectName: name,
            hours: 0,
            billedLabor: 0,
            laborCost: 0,
            billedExpenses: billedAmount,
            expenses: expenseCost,
            revenue: billedAmount,
            cost: expenseCost,
            profit: billedAmount
          });
        }
      }
      return projectData;
    },
    lastSubmission() {
      let submission = null;
      if (this.timeSubmissions != null) {
        for (var sub of this.timeSubmissions) {
          if (submission == null) {
            submission = sub;
          } else {
            if (
              moment(
                submission.date + " " + submission.timeOut,
                "YYYY-MM-DD hh:mm A"
              ) < moment(sub.date + " " + sub.timeOut, "YYYY-MM-DD hh:mm A")
            ) {
              submission = sub;
            }
          }
        }
      }

      return submission;
    }
  },
  watch: {
    userStoreData() {
      this.users = [];
      for (var userId of Object.keys(this.userStoreData)) {
        this.users.push(JSON.parse(JSON.stringify(this.userStoreData[userId])));
      }
    },
    financeView(val) {
      if (val == true) {
        this.selectedUserNames = this.userNames;
        this.selectedUserIds = this.userIds;
      } else {
        this.selectedUserNames = [this.userStoreData[this.submitUserId].name];
        this.selectedUserIds = [this.submitUserId];
      }
      this.updateUserSelect();
    },
    selectedDate() {
      let begin = moment().startOf(this.selectedDate);
      let end = moment().endOf(this.selectedDate);

      this.dates = [begin.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")];
      if (this.selectedDate == "week") {
        this.dateRangeText =
          begin.format("MMM DD, YYYY") + " ~ " + end.format("MMM DD, YYYY");
      } else if (this.selectedDate == "month") {
        this.dateRangeText = begin.format("MMMM YYYY");
      } else if (this.selectedDate == "quarter") {
        this.dateRangeText =
          begin.format("MMM") + " ~ " + end.format("MMM YYYY");
      } else if (this.selectedDate == "year") {
        this.dateRangeText =
          begin.format("MMM") + " ~ " + end.format("MMM YYYY");
      }

      this.testing = "SelectedDate";
      this.loadedTimeSubmissions = [];
      this.loadedExpenseSubmissions = [];
      this.timeSubmissions = [];
      this.expenseSubmissions = [];
      this.loadedUserNames = [];
      this.loadedUserIds = [];
      this.updateUserSelect();
    },
    loggedInUser(newVal, oldVal) {
      if (newVal != null && oldVal == null) {
        this.loadData();
      }
    }
  },
  methods: {
    nextDateRange() {
      let begin = moment(this.dates[0]);
      let end = moment(this.dates[1]);
      let newBegin = begin.add(1, this.selectedDate);
      let newEnd = end.add(1, this.selectedDate);
      if (this.selectedDate == "month") {
        this.dates[0] = newBegin.format("YYYY-MM-01");
        this.dates[1] =
          newEnd.format("YYYY-MM-") +
          moment(newEnd.format("YYYY-MM"), "YYYY-MM").daysInMonth();
      } else {
        this.dates[0] = newBegin.format("YYYY-MM-DD");
        this.dates[1] = newEnd.format("YYYY-MM-DD");
      }

      if (this.selectedDate == "week") {
        this.dateRangeText =
          begin.format("MMM DD") + " ~ " + end.format("MMM DD, YYYY");
      } else if (this.selectedDate == "month") {
        this.dateRangeText = begin.format("MMMM YYYY");
      } else if (this.selectedDate == "quarter") {
        this.dateRangeText =
          begin.format("MMM") + " ~ " + end.format("MMM YYYY");
      } else if (this.selectedDate == "year") {
        this.dateRangeText =
          begin.format("MMM") + " ~ " + end.format("MMM YYYY");
      }

      this.testing = "SelectedDate";
      this.loadedTimeSubmissions = [];
      this.loadedExpenseSubmissions = [];
      this.timeSubmissions = [];
      this.expenseSubmissions = [];
      this.loadedUserNames = [];
      this.loadedUserIds = [];
      this.updateUserSelect();
    },
    prevDateRange() {
      let begin = moment(this.dates[0]);
      let end = moment(this.dates[1]);
      let newBegin = begin.subtract(1, this.selectedDate);
      let newEnd = end.subtract(1, this.selectedDate);
      if (this.selectedDate == "month") {
        this.dates[0] = newBegin.format("YYYY-MM-01");
        this.dates[1] =
          newEnd.format("YYYY-MM-") +
          moment(newEnd.format("YYYY-MM"), "YYYY-MM").daysInMonth();
      } else {
        this.dates[0] = newBegin.format("YYYY-MM-DD");
        this.dates[1] = newEnd.format("YYYY-MM-DD");
      }

      if (this.selectedDate == "week") {
        this.dateRangeText =
          begin.format("MMM DD") + " ~ " + end.format("MMM DD, YYYY");
      } else if (this.selectedDate == "month") {
        this.dateRangeText = begin.format("MMMM YYYY");
      } else if (this.selectedDate == "quarter") {
        this.dateRangeText =
          begin.format("MMM") + " ~ " + end.format("MMM YYYY");
      } else if (this.selectedDate == "year") {
        this.dateRangeText =
          begin.format("MMM") + " ~ " + end.format("MMM YYYY");
      }

      this.testing = "SelectedDate";
      this.loadedTimeSubmissions = [];
      this.loadedExpenseSubmissions = [];
      this.timeSubmissions = [];
      this.expenseSubmissions = [];
      this.loadedUserNames = [];
      this.loadedUserIds = [];
      this.updateUserSelect();
    },
    updateUserSelect() {
      this.$refs.select.isMenuActive = false;
      let usersToLoad = [];
      for (var i = 0; i < this.selectedUserNames.length; i++) {
        let alreadyLoaded = false;
        for (var j = 0; j < this.loadedUserNames.length; j++) {
          if (this.selectedUserNames[i] == this.loadedUserNames[j]) {
            alreadyLoaded = true;
            break;
          }
        }
        if (alreadyLoaded == false) {
          for (var id of Object.keys(this.userStoreData)) {
            let user = JSON.parse(JSON.stringify(this.userStoreData[id].name));
            if (user == this.selectedUserNames[i]) {
              usersToLoad.push(id);
            }
          }
        }
      }
      if (usersToLoad.length > 0) {
        this.getTimeSubmissions(usersToLoad);
        this.getExpenseSubmissions(usersToLoad);
      } else {
        this.timeSubmissions = [];
        this.expenseSubmissions = [];
        for (i = 0; i < this.loadedTimeSubmissions.length; i++) {
          for (j = 0; j < this.selectedUserNames.length; j++) {
            if (
              this.loadedTimeSubmissions[i].userName ==
              this.selectedUserNames[j]
            ) {
              this.timeSubmissions.push(this.loadedTimeSubmissions[i]);
              break;
            }
          }
        }
        for (i = 0; i < this.loadedExpenseSubmissions.length; i++) {
          for (j = 0; j < this.selectedUserNames.length; j++) {
            if (
              this.loadedExpenseSubmissions[i].userName ==
              this.selectedUserNames[j]
            ) {
              this.expenseSubmissions.push(this.loadedExpenseSubmissions[i]);
              break;
            }
          }
        }
      }
    },
    loadData() {
      this.userNames = [];
      this.userIds = [];

      let begin = moment().startOf(this.selectedDate);
      let end = moment().endOf(this.selectedDate);

      this.dates = [begin.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")];
      this.dateRangeText =
        begin.format("MMM DD") + " ~ " + end.format("MMM DD, YYYY");
      this.selected;
      for (var userId of Object.keys(this.userStoreData)) {
        let user = JSON.parse(JSON.stringify(this.userStoreData[userId].name));
        this.userNames.push(user);
        this.userIds.push(userId);
        this.selectedUserNames.push(user);
        this.selectedUserIds.push(userId);
      }
      this.getTimeSubmissions(this.selectedUserIds);
      this.getExpenseSubmissions(this.selectedUserIds);
    },
    successHandler(message) {
      this.successMessage = message;
      this.showTimeSubmissionForm = false;
      setTimeout(function() {
        this.successMessage = null;
      }, 2000);
    },
    successHandlerExpense(message) {
      this.successMessage = message;
      this.showExpenseSubmissionForm = false;
      setTimeout(function() {
        this.successMessage = null;
      }, 2000);
    },
    loadTimeSubmissionForm(action) {
      this.formAction = action;
      this.showTimeSubmissionForm = true;
    },
    loadExpenseSubmissionForm(action) {
      this.expenseFormAction = action;
      this.showExpenseSubmissionForm = true;
    },
    updateTable(event) {
      this.testing = event;
      if (event.action == "add" || event.action == "edit") {
        event.item.laborRate = event.item.laborRate / 1.0;
        event.item.userName = this.userStoreData[event.item.userId].name;
        event.item.projectName = this.projects[event.item.projectId].name;
        event.item.laborCost = event.item.laborRate * event.item.duration;
        event.item.hours = event.item.duration;
        let itemDate = moment(event.item.date, "YYYY-MM-DD");
        if (
          itemDate >= moment(this.dates[0], "YYYY-MM-DD") &&
          itemDate <= moment(this.dates[1], "YYYY-MM-DD")
        ) {
          if (event.action == "add") {
            this.timeSubmissions.unshift(event.item);
            this.loadedTimeSubmissions.unshift(event.item);
          } else if (event.action == "edit") {
            for (
              var index = 0;
              index < this.loadedTimeSubmissions.length;
              index++
            ) {
              if (this.loadedTimeSubmissions[index].id == event.item.id) {
                this.loadedTimeSubmissions.splice(index, 1, event.item);
              }
            }
            for (index = 0; index < this.timeSubmissions.length; index++) {
              if (this.timeSubmissions[index].id == event.item.id) {
                this.timeSubmissions.splice(index, 1, event.item);
              }
            }
          }
        }
      } else if (event.action == "delete") {
        for (var i = 0; i < this.timeSubmissions.length; i++) {
          if (this.timeSubmissions[i].id == event.item) {
            this.timeSubmissions.splice(i, 1);
          }
        }
        for (i = 0; i < this.loadedTimeSubmissions.length; i++) {
          if (this.loadedTimeSubmissions[i].id == event.item) {
            this.loadedTimeSubmissions.splice(i, 1);
          }
        }
      }
    },
    updateExpenseTable(event) {
      if (event.action == "add" || event.action == "edit") {
        event.item.userName = this.userStoreData[event.item.userId].name;
        event.item.projectName = this.projects[event.item.projectId].name;
        let itemDate = moment(event.item.date, "YYYY-MM-DD");
        if (
          itemDate >= moment(this.dates[0], "YYYY-MM-DD") &&
          itemDate <= moment(this.dates[1], "YYYY-MM-DD")
        ) {
          if (event.action == "add") {
            this.expenseSubmissions.unshift(event.item);
            this.loadedExpenseSubmissions.unshift(event.item);
          } else if (event.action == "edit") {
            for (
              var index = 0;
              index < this.expenseSubmissions.length;
              index++
            ) {
              if (this.expenseSubmissions[index].id == event.item.id) {
                this.expenseSubmissions.splice(index, 1, event.item);
              }
            }
            for (
              index = 0;
              index < this.loadedExpenseSubmissions.length;
              index++
            ) {
              if (this.loadedExpenseSubmissions[index].id == event.item.id) {
                this.loadedExpenseSubmissions.splice(index, 1, event.item);
              }
            }
          }
        }
      } else if (event.action == "delete") {
        for (var i = 0; i < this.expenseSubmissions.length; i++) {
          if (this.expenseSubmissions[i].id == event.item) {
            this.expenseSubmissions.splice(i, 1);
          }
        }
        for (i = 0; i < this.loadedExpenseSubmissions.length; i++) {
          if (this.loadedExpenseSubmissions[i].id == event.item) {
            this.loadedExpenseSubmissions.splice(i, 1);
          }
        }
      }
    },
    editTimeSubmission(item) {
      this.resetErrors();
      this.timeSubmissionData = JSON.parse(JSON.stringify(item));
      // if (this.loggedInUser.type != "Admin") {
      //   let itemDate = moment(item.date, "YYYY-MM-DD");
      //   if (
      //     itemDate >= moment().startOf("week") &&
      //     itemDate <= moment().endOf("week")
      //   ) {
      //     this.showEditSubmissionDialog = true;
      //   }
      // } else {
      this.formAction = "Edit";
      this.showTimeSubmissionForm = true;
      // }
    },
    editExpenseSubmission(item) {
      this.resetErrors();
      this.expenseSubmissionData = JSON.parse(JSON.stringify(item));
      // if (this.loggedInUser.type != "Admin") {
      //   let itemDate = moment(item.date, "YYYY-MM-DD");
      //   if (
      //     itemDate >= moment().startOf("week") &&
      //     itemDate <= moment().endOf("week")
      //   ) {
      //     this.showEditSubmissionDialog = true;
      //   }
      // } else {
      this.expenseFormAction = "Edit";
      this.showExpenseSubmissionForm = true;
      // }
    },
    getSubmissionImage(item) {
      let payload = {
        action: "getObject",
        path: item.s3FilePath
      };
      let fileArr = item.s3FilePath.split("/");
      this.s3ImageName = fileArr[fileArr.length - 1];
      this.s3ImageContentType = item.s3FileContentType;

      this.$store.dispatch("getPresignedUrl", payload).then(result => {
        if (result.success == false) {
          this.errorMessage = result.data.error.message;
        } else {
          if (item.s3FileContentType.split("/")[0] == "image") {
            self.fileLink = result.data;
            self.showFileDialog = true;
          } else {
            window.open(result.data, "_blank");
          }
        }
      });
    },
    resetErrors() {
      this.errorMessage = null;
      this.successMessage = null;
      this.dialogSuccessMessage = null;
      this.dialogErrorMessage = null;
    },
    getTimeSubmissions: function(usersToLoad) {
      this.resetErrors();
      if (this.loggedInUser != null) {
        this.loadingText = "Getting Time Submissions";
        this.loading = true;
        let payload = {
          userId: usersToLoad,
          startDate: this.dates[0],
          endDate: this.dates[1]
        };
        let self = this;
        self.$store.dispatch("getTimeSubmissions", payload).then(result => {
          if (result.success != true) {
            self.errorMessage = result.data.error.message;
          } else {
            self.loadedUserIds = self.loadedUserIds.concat(usersToLoad);
            for (var uId of usersToLoad) {
              self.loadedUserNames.push(
                JSON.parse(JSON.stringify(this.userStoreData[uId].name))
              );
            }
            for (var timeSubmission of result.data) {
              if (self.projects[timeSubmission.projectId] != null) {
                timeSubmission.projectName =
                  self.projects[timeSubmission.projectId].name;
              }
              if (self.userStoreData[timeSubmission.userId] != null) {
                timeSubmission.userName =
                  self.userStoreData[timeSubmission.userId].name;
              }
              self.loadedTimeSubmissions.push(timeSubmission);
            }
            self.timeSubmissions = [];
            for (var i = 0; i < self.loadedTimeSubmissions.length; i++) {
              for (var j = 0; j < self.selectedUserNames.length; j++) {
                if (
                  self.loadedTimeSubmissions[i].userName ==
                  self.selectedUserNames[j]
                ) {
                  self.timeSubmissions.push(self.loadedTimeSubmissions[i]);
                  break;
                }
              }
            }
            self.loadingText = null;
            self.loading = false;
          }
        });
      }
    },
    getExpenseSubmissions: function(usersToLoad) {
      this.resetErrors();
      if (this.loggedInUser != null) {
        this.loadingExpenseText = "Getting Expense Submissions";
        this.loadingExpense = true;
        let payload = {
          userId: usersToLoad,
          startDate: this.dates[0],
          endDate: this.dates[1]
        };
        let self = this;
        self.$store.dispatch("getExpenseSubmissions", payload).then(result => {
          if (result.success != true) {
            self.errorMessage = result.data.error.message;
          } else {
            for (var expenseSubmission of result.data) {
              if (self.projects[expenseSubmission.projectId] != null) {
                expenseSubmission.projectName =
                  self.projects[expenseSubmission.projectId].name;
              }
              if (self.userStoreData[expenseSubmission.userId] != null) {
                expenseSubmission.userName =
                  self.userStoreData[expenseSubmission.userId].name;
              }
              self.loadedExpenseSubmissions.push(expenseSubmission);
            }
            self.expenseSubmissions = [];
            for (var i = 0; i < self.loadedExpenseSubmissions.length; i++) {
              for (var j = 0; j < self.selectedUserNames.length; j++) {
                if (
                  self.loadedExpenseSubmissions[i].userName ==
                  self.selectedUserNames[j]
                ) {
                  self.expenseSubmissions.push(
                    self.loadedExpenseSubmissions[i]
                  );
                  break;
                }
              }
            }
            self.loadingExpenseText = null;
            self.loadingExpense = false;
          }
        });
      }
    },
    addProjectToSubmissions() {
      for (var timeSubmission of this.newTimeSubmissions) {
        if (this.projects[timeSubmission.projectId] != null) {
          timeSubmission.projectName = this.projects[
            timeSubmission.projectId
          ].name;
        }
        if (this.userStoreData[timeSubmission.userId] != null) {
          timeSubmission.userName = this.userStoreData[
            timeSubmission.userId
          ].name;
        }
        this.timeSubmissions.push(timeSubmission);
      }
    },
    addProjectToExpenseSubmissions() {
      for (var expenseSubmission of this.expenseSubmissions) {
        if (this.projects[expenseSubmission.projectId] != null) {
          expenseSubmission.projectName = this.projects[
            expenseSubmission.projectId
          ].name;
        }
        if (this.userStoreData[expenseSubmission.userId] != null) {
          expenseSubmission.userName = this.userStoreData[
            expenseSubmission.userId
          ].name;
        }
      }
    }
  },
  beforeMount() {
    if (this.loggedInUser != null) {
      this.loadData();
    }
  }
};
</script>
